import React, { useEffect, useState } from 'react';

import secureMode from '../../../main/assets/images/powerMeterV2/security-icon.webp';
import battery from '../../../main/assets/images/powerMeterV2/battery-icon.webp';
import powerScope from '../../../main/assets/images/powerMeterV2/power-scope-icon.webp';

export const Cards = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className="power-meter-cards">
      <div className="power-meter-card">
        <img
          src={secureMode}
          className="power-meter-card-icon"
          alt="Security Icon"
        />
        <div className="power-meter-card-text">
          <h2 className="power-meter-card-title">
            {windowWidth > 991 && windowWidth <= 1200 ? (
              <>
                <span style={{ whiteSpace: 'nowrap', display: 'block' }}>
                  Touch-Free
                </span>
                <span style={{ whiteSpace: 'nowrap', display: 'block' }}>
                  Testing
                </span>
              </>
            ) : (
              <>Touch-Free Testing</>
            )}
          </h2>
          <p className="power-meter-card-description">
            Use the included stubby dipole to wirelessly test quads - no antenna
            removal needed. Spot violators or faulty gear easily, keeping races
            fair and safe.
          </p>
        </div>
      </div>
      <div className="power-meter-card">
        <img
          src={battery}
          className="power-meter-card-icon"
          alt="Battery Icon"
        />
        <div className="power-meter-card-text">
          <h2 className="power-meter-card-title">
            {windowWidth > 991 && windowWidth <= 1200 ? (
              <>
                <span style={{ whiteSpace: 'nowrap', display: 'block' }}>
                  Built-in
                </span>
                <span style={{ whiteSpace: 'nowrap', display: 'block' }}>
                  Battery
                </span>
              </>
            ) : (
              <>Built-in Battery</>
            )}
          </h2>
          <p className="power-meter-card-description power-meter-card-description-smaller">
            Get over 8 hours per charge. Auto-shutdown conserves power, and fast
            USB charging gets you back in under an hour.
          </p>
        </div>
      </div>
      <div className="power-meter-card">
        <img
          src={powerScope}
          className="power-meter-card-icon"
          alt="Power Scope Icon"
        />
        <div className="power-meter-card-text">
          <h2 className="power-meter-card-title">
            {windowWidth > 991 && windowWidth <= 1200 ? (
              <>
                <span style={{ whiteSpace: 'nowrap', display: 'block' }}>
                  PowerScope
                </span>
                <span style={{ whiteSpace: 'nowrap', display: 'block' }}>
                  Mode
                </span>
              </>
            ) : (
              <>PowerScope Mode</>
            )}
          </h2>
          <p className="power-meter-card-description">
            Visualize RF signals, monitor packet timing, and check antennas.
            Detects LBT & Duty Cycle limits for deeper analysis and full
            compliance insight.
          </p>
        </div>
      </div>
    </div>
  );
};
